import { useQuery } from '@tanstack/react-query';

import fetchAllianceData from '~api/fetchAllianceData';

type AllianceResponse =
    | [
          {
              partnerAllianceInfo: {
                  suppressEmailCapturePopup: string;
                  allianceData: {
                      partnerDisplayName: string;
                      serviceHours: string;
                      throttle: IThrottle;
                      allianceInfo: {
                          allianceLogo: string;
                          allianceCompanyUrl: string;
                          tcpaDisclaimer: string;
                      };
                  };
                  lightModeHeader: string;
                  partnershipType: string;
                  segmentType: string;
                  landingPageConfigs: LandingPageConfig[];
              };
          },
          'success' | 'idle',
      ]
    | [
          {
              allianceId: string;
              partnerAllianceInfo: null;
          },
          'error' | 'loading' | 'pending',
      ];

export default function useAllianceData(allid: string) {
    const { data, status } = useQuery({
        queryKey: ['allianceInfo', allid],
        queryFn: fetchAllianceData,
    });

    return [
        data?.data ?? {
            allianceId: allid,
            partnerAllianceInfo: null,
        },
        status,
    ] as AllianceResponse;
}
